export enum TopPathsNodeType {
  Anchor = `ANCHOR`,
  Dropoff = `DROPOFF`,
  Pruned = `PRUNED`,
  Event = `EVENT`,
  Empty = `EMPTY`,
}
